import { post, postData } from "../../util/Api";
import { Invoice } from "../InvoiceModel";

export interface DailyReportMember {
  createdAt: Date | null;
  updatedAt: Date | null;
  my_user_id: number;
  other_user_id: number;
  companyId: number;
}

// DailyReportMember class implementing the interface
export class DailyReportMemberModel {
  static set(data: any): DailyReportMember {
    const d: DailyReportMember = {
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      my_user_id: data.my_user_id,
      other_user_id: data.other_user_id,
      companyId: data.companyId,
    };

    return d;
  }

  static async save(params: { other_user_ids: number[] }): Promise<void> {
    const uri = `/daily_reports/members/save`;
    let response = await postData(uri, params);
  }
}
